import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TravelsRoutingModule } from './travels-routing.module';
import { TravelsListComponent } from './travels-list/travels-list.component';
import { PrimeModule } from '../../shared/primeng/primeng-module';
import { ReactiveFormsModule } from '@angular/forms';
import { TravelPageComponent } from './travel-page/travel-page.component';
import { AllDestinationsComponent } from './all-destinations/all-destinations.component';
import { DeparturesComponent } from './departures/departures.component';
import { TravelManagementComponent } from './travel-management/travel-management.component';
import { TravelManagementUserComponent } from './travel-management-user/travel-management-user.component';
import { SharedModule } from '../../shared/shared.module';
import { NewTravelComponent } from './new-travel/new-travel.component';
import { SearchTravelsComponent } from './search-travels/search-travels.component';
import { TravelJoinComponent } from './travel-join/travel-join.component';
import { TravelJoinGMGComponent } from './travel-join-gmg/travel-join-gmg.component';
import { TravelJoinDonateComponent } from './travel-join-donate/travel-join-donate.component';
// import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({
  declarations: [
    TravelsListComponent,
    TravelPageComponent,
    AllDestinationsComponent,
    DeparturesComponent,
    TravelManagementComponent,
    TravelManagementUserComponent,
    NewTravelComponent,
    SearchTravelsComponent,
    TravelJoinComponent,
    TravelJoinGMGComponent,
    TravelJoinDonateComponent,
  ],
  imports: [
    CommonModule,
    TravelsRoutingModule,
    PrimeModule,
    ReactiveFormsModule,
    SharedModule,
    // DragDropModule,
  ],
  exports: [
    CommonModule,
    TravelsRoutingModule,
    PrimeModule,
    ReactiveFormsModule,
    SharedModule,
  ],
})
export class TravelsModule {}
